import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '@/../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

export default {
  computed: {
    $tailwind() {
      return fullConfig;
    },
    $theme() {
      return this.$tailwind.theme;
    },
    $screen() {
      const screens = this.$theme.screens;
      const windowWidth = window.innerWidth;

      for (const [name, width] of Object.entries(screens)) {
        if (windowWidth < parseInt(width)) {
          return name;
        }
      }
    }
  }
}
